import { render, staticRenderFns } from "./DoctorForm.vue?vue&type=template&id=328c3641&scoped=true&"
import script from "./DoctorForm.vue?vue&type=script&lang=js&"
export * from "./DoctorForm.vue?vue&type=script&lang=js&"
import style0 from "./DoctorForm.vue?vue&type=style&index=0&id=328c3641&scoped=true&lang=css&"
import style1 from "./DoctorForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c3641",
  null
  
)

export default component.exports